import { Opportunity } from "@entities";
import { Box } from "@mui/material";
import { useCreateHyperTable } from "@shared/frontend/hyper-table";
import { type FC } from "react";
import { formatGroupSlotSchedule } from "./format-group-slot-schedule";
import { GroupInstanceStatusBadge } from "./GroupInstanceStatusBadge";

export const GroupOpportunitySlotsTable: FC<{
  rows: Opportunity[];
  tableId: string;
  tourAnchors?: boolean;
  onRowClick?: (row: Opportunity) => void;
}> = ({ rows, tableId, tourAnchors = false, onRowClick }) => {
  const { HyperTable } = useCreateHyperTable(Opportunity);

  return (
    <Box
      data-tour={tourAnchors ? "cc-mock-instances-table" : undefined}
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <HyperTable
        tableId={tableId}
        title={null}
        findConfig={{
          enabled: true,
          where: {},
        }}
        queryOptions={{
          dataFn: async () => rows,
          countFn: async () => rows.length,
          deps: [rows],
        }}
        onRowClick={
          onRowClick ? (_, row) => onRowClick(row.original) : undefined
        }
      >
        <HyperTable.Toolbar />
        <HyperTable.Column
          field="startDate"
          caption="תאריך"
          enableSorting
          minSize={180}
          cell={({ row }) => formatGroupSlotSchedule(row.original)}
        />
        <HyperTable.Column
          field="location"
          caption="מיקום"
          cell={({ row }) =>
            row.original.isRemote ? "מרחוק" : row.original.location || "-"
          }
        />
        <HyperTable.Column
          field="participantsCount"
          caption="משתתפים"
          minSize={100}
          size={120}
          cell={({ row }) =>
            `${row.original.participantsCount ?? 0} / ${row.original.amount ?? 1}`
          }
        />
        <HyperTable.Column
          field="isClosed"
          caption="סטטוס"
          minSize={140}
          enableSorting={false}
          cell={({ row }) => <GroupInstanceStatusBadge child={row.original} />}
        />
      </HyperTable>
    </Box>
  );
};
